import React from 'react';

import { getColumnSearchProps } from '../../../components/ColumnSearchProps';
import { DeleteOutlined } from '../Monetizacao/TarifasCliente/styles';
import {
  ActionButton,
  ContainerButtons,
  SendOutlined,
  UserOutlined,
} from './styles';

const handleActions = (record, handleEditStatusUser, handleSendEmailUser) => {
  const { status, idUsuario } = record;
  let content;

  switch (status) {
    case 'ATIVO':
      content = (
        <>
          <ActionButton
            type="link"
            onClick={() => handleEditStatusUser(idUsuario, 'REMOVIDO')}
          >
            <DeleteOutlined />
          </ActionButton>
        </>
      );
      break;
    case 'PENDENTE':
      content = (
        <>
          <ActionButton type="link" onClick={() => handleSendEmailUser(record)}>
            <SendOutlined />
          </ActionButton>
          <ActionButton
            type="link"
            onClick={() => handleEditStatusUser(idUsuario, 'REMOVIDO')}
          >
            <DeleteOutlined />
          </ActionButton>
        </>
      );
      break;
    case 'REMOVIDO':
      content = (
        <>
          <ActionButton
            type="link"
            onClick={() => handleEditStatusUser(idUsuario, 'ATIVO')}
          >
            <UserOutlined />
          </ActionButton>
        </>
      );
      break;
    default:
      content = <></>;
  }

  return <ContainerButtons>{content}</ContainerButtons>;
};

export const getColumns = (
  filters,
  handleEditStatusUser,
  handleSendEmailUser
) => {
  // colunas da tabela
  const columns = [
    {
      title: 'Nome',
      dataIndex: 'nome',
      key: 'name',
      width: '30%',
      filteredValue: filters.nome,
      sorter: true,
      ...getColumnSearchProps(),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '20%',
      filteredValue: filters.email,
      sorter: true,
      ...getColumnSearchProps(),
    },
    {
      title: 'Último acesso',
      dataIndex: 'ultimoAcesso',
      key: 'ultimo_acesso',
      width: '20%',
      align: 'center',
      filteredValue: filters.ultimoAcesso,
      sorter: true,
      render: texto => texto || '-',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: '10%',
      align: 'center',
      sorter: true,
      filters: [
        { text: 'ATIVO', value: 'ATIVO' },
        { text: 'REMOVIDO', value: 'REMOVIDO' },
        { text: 'PENDENTE', value: 'PENDENTE' },
      ],
    },

    {
      title: 'Ações',
      width: '10%',
      align: 'center',
      render: record =>
        handleActions(record, handleEditStatusUser, handleSendEmailUser),
    },
  ];

  return columns;
};
